import type {
  SendInvitationReminderMutation,
  SendInvitationReminderMutationVariables
} from './__generated__/SendInvitationReminderMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  SendInvitationReminderMutation,
  SendInvitationReminderMutationVariables
> = gql`
  mutation SendInvitationReminderMutation(
    $input: SendInvitationReminderInput!
  ) {
    sendInvitationReminder(input: $input) {
      status
    }
  }
`

export function sendInvitationReminderMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      SendInvitationReminderMutation,
      SendInvitationReminderMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
